import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/ConfirmDialog';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ErrorBoundary>
            <BrowserRouter>
                <ToastProvider>
                    <ConfirmProvider>
                        <App />
                    </ConfirmProvider>
                </ToastProvider>
            </BrowserRouter>
        </ErrorBoundary>
    </React.StrictMode>
);

/* Register service worker for PWA install support */
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {
            /* Silent fail — PWA install just won't be available */
        });
    });
}
